import session from './session'

const URL = process.env.VUE_APP_API_URL

export default {
  login (username, password) {
    return session.post(URL + 'auth/login/', { username, password })
  },
  // getToken () {
  //   return session.get(URL + 'get-token/', {})
  // },
  logout () {
    return session.post(URL + 'auth/logout/', {})
  },
  user () {
    // return session.get(URL + 'auth/user/', {params: {'p': 12, 'sad': 'asd'}})
    return session.get(URL + 'auth/user/')
  }
}
